<template>
  <iframe
    :src="shareInfo.activityTemplet"
    frameborder="0"
  ></iframe>
</template>

<script>
export default {
  props: {
    shareInfo: Object
  },
};
</script>
        
<style scoped>
iframe {
  width: 100%;
  height: 100vh;
}
</style>
